module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-share-getChance"><div class="notShare sma"><p>抽奖机会已用完，分享给好友可额外获得</p><p>1次抽奖机会哦!</p><div class="logo">分享至： <span class="QZ" onclick="lottery.shareTo(\'qzone\');"></span> <span class="WB" onclick="lottery.shareTo(\'sina\')"></span> <span class="QQ" onclick="lottery.shareTo(\'qq\')"></span></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/share.getChance.html
// module id = 29
// module chunks = 0